import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { register } from "../store/actions/authAction";
import Navbar from "../components/layout/Navbar";
import { message } from "antd";

const Register = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const registerUser = (e) => {
    e.preventDefault();

    const user = {
      username,
      password,
      password2,
    };
    if (username === "") {
      message.error("Username is must.");
    } else if (password === "") {
      message.error("Password is must.");
    } else if (password2 === "") {
      message.error("Confirm Password is must.");
    } else {
      dispatch(register(user, history));
    }
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row justify-content-center align-items-center h-80vh ">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="card">
              <form onSubmit={registerUser}>
                <div className="card-body m-5">
                  <h5 className="card-title mb-3">Make an Account</h5>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                      value={password2}
                      onChange={(e) => setPassword2(e.target.value)}
                    />
                  </div>

                  <button className="btn btn-primary btn-sm form-control">
                    Register
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
